module.exports = __webpack_public_path__ + "static/media/red_joker.01490958.png";